module.exports = __webpack_public_path__ + "img/image8.2af5536f.jpg";